import React from 'react';
import styles from './styles.css';
import PortfolioAllocation from '../PortfolioAllocation/PortfolioAllocation';
import { mapFundAllocation } from '../../hooks/useCartDetailsState';

const FundCompositionSection = ({
  fund,
  openQuickViewFund,
  setOpenQuickViewFund,
  RDFData = false,
  isMoneyMarketView = false
}) => {
  const { allocation } = mapFundAllocation(fund);
  const {
    stocks,
    bonds,
    shortTermReserves,
    fundAllocationsPresent
  } = allocation;
  return (
    <div className="fund-composition-section">
      <PortfolioAllocation
        fund={fund}
        stocks={stocks}
        bonds={bonds}
        shortTerm={shortTermReserves}
        shoppingCartEmpty={false}
        displayHeader={RDFData || isMoneyMarketView}
        open
        openQuickViewFund={openQuickViewFund}
        setOpenQuickViewFund={setOpenQuickViewFund}
        RDFData={RDFData}
        isMoneyMarketView={isMoneyMarketView}
        fundAllocationsPresent={fundAllocationsPresent}
      />
      <style jsx>{styles}</style>
    </div>
  );
};

export default FundCompositionSection;
